import type { AllSitesDashboard, SiteDashboard } from "./types/dashboard.types";
import { API_BASE_URL } from "./config";

const ALL_SITES_PATH = "/app/dashboard";
const SITE_PATH = (siteId: number) => `/app/dashboard/sites/${siteId}`;

async function getJson<T>(path: string): Promise<T> {
  const url = `${API_BASE_URL}${path}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`GET ${url} ${res.status}`);
  const json = await res.json();
  return json.data as T;
}

function byTimeDesc<T extends { id: number; timestamp: string }>(events: T[]): T[] {
  return [...events].sort((a, b) => {
    const d = Date.parse(b.timestamp) - Date.parse(a.timestamp);
    if (d !== 0 && !Number.isNaN(d)) return d;
    return b.id - a.id;
  });
}

async function getAllSites(): Promise<AllSitesDashboard> {
  const data = await getJson<AllSitesDashboard>(ALL_SITES_PATH);
  return { ...data, events: byTimeDesc(data.events ?? []) };
}

async function getSite(siteId: number): Promise<SiteDashboard> {
  const data = await getJson<SiteDashboard>(SITE_PATH(siteId));
  return { ...data, events: byTimeDesc(data.events ?? []) };
}

export const dashboardService = {
  getAllSites,
  getSite,
};
